<template>
    <!-- 主持人简介 -->
    <div class="hostIntroduce">
        <div class="introduce-item">
            <div class="title-warp">
                <h3 class="title">主持人简介</h3>
            </div>
            <div class="text">
                <p class="section">
                    王海燕——现任国家教育咨询委员会委员、第一组组长、教育部社会科学委员会副主任、教育部新时代中国特色社会主义思想研究中心顾问、国家教育发展研究中心专家咨询委员会副主任委员、国家教师教育咨询专家委员会主任委员、教育部教师教育专家委员会主任委员、普通高等学校师范类专业认证专家委员会副主任、全国师德师风建设专家委员会总顾问
                    、中国教育学会名誉会长 等职务。曾任世界比较教育学会联合会主席，国务院学位委员会教育学科评议组召集人
                    ，国家教委中小学教材审定委员会副主任，全国教育硕士专业学位教育指导委员会主任，北京师范大学副校长；兼任北京大学、清华大学等院校兼职教授。担任《比较教育研究》、《中国教育学刊》等杂志主编，《教育研究》等多家学术期刊学术委员会顾问
                    [3] 。多次担任国家及教育部重大项目的负责人，主编《教育大辞典》、《中国教育大百科全书》等多部大型教育辞书，出版专著40余部，发表论文千余篇 。
                </p>
                <p class="section">
                    王海燕——现任国家教育咨询委员会委员、第一组组长、教育部社会科学委员会副主任、教育部新时代中国特色社会主义思想研究中心顾问、国家教育发展研究中心专家咨询委员会副主任委员、国家教师教育咨询专家委员会主任委员、教育部教师教育专家委员会主任委员、普通高等学校师范类专业认证专家委员会副主任、全国师德师风建设专家委员会总顾问
                    、中国教育学会名誉会长 等职务。曾任世界比较教育学会联合会主席，国务院学位委员会教育学科评议组召集人
                    ，国家教委中小学教材审定委员会副主任，全国教育硕士专业学位教育指导委员会主任，北京师范大学副校长；兼任北京大学、清华大学等院校兼职教授。担任《比较教育研究》、《中国教育学刊》等杂志主编，《教育研究》等多家学术期刊学术委员会顾问
                    [3] 。多次担任国家及教育部重大项目的负责人，主编《教育大辞典》、《中国教育大百科全书》等多部大型教育辞书，出版专著40余部，发表论文千余篇 。
                </p>
                <p class="section">
                    王海燕——现任国家教育咨询委员会委员、第一组组长、教育部社会科学委员会副主任、教育部新时代中国特色社会主义思想研究中心顾问、国家教育发展研究中心专家咨询委员会副主任委员、国家教师教育咨询专家委员会主任委员、教育部教师教育专家委员会主任委员、普通高等学校师范类专业认证专家委员会副主任、全国师德师风建设专家委员会总顾问
                    、中国教育学会名誉会长 等职务。曾任世界比较教育学会联合会主席，国务院学位委员会教育学科评议组召集人
                    ，国家教委中小学教材审定委员会副主任，全国教育硕士专业学位教育指导委员会主任，北京师范大学副校长；兼任北京大学、清华大学等院校兼职教授。担任《比较教育研究》、《中国教育学刊》等杂志主编，《教育研究》等多家学术期刊学术委员会顾问
                    [3] 。多次担任国家及教育部重大项目的负责人，主编《教育大辞典》、《中国教育大百科全书》等多部大型教育辞书，出版专著40余部，发表论文千余篇 。
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="less" scoped>
    .introduce-item {
        &:nth-child(2) .title {
            background-image: url("../../assets/studio/title-2.png");
        }

        &:nth-child(3) .title {
            background-image: url("../../assets/studio/title-3.png");
        }
    }

    .title-warp {
        border-bottom: 1px solid #A98EED;
        padding-bottom: 14px;
    }

    .title {
        background-color: #4EB4F4;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        font-size: 24px;
        line-height: 2.1;
        color: #fff;
        font-weight: bold;
        padding: 0 3.7% 0 6.2%;
        width: 21%;
        box-sizing: border-box;
        position: relative;

        &::before {
            content: " ";
            width: 28px;
            height: 48px;
            background-image: url("../../assets/studio/Icon_Bookmark.png");
            background-repeat: no-repeat;
            position: absolute;
            top: 0;
            left: 14px;
        }
    }

    .text {
        padding: 3% 0 0 0;
        font-size: 18px;
        line-height: 2.2;
        font-weight: 300;
    }

    .section {
        margin-bottom: 15px;
        text-indent: 2em;
    }
</style>